
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SaplingScreenCapturePreview extends Vue {
  @Prop({ type: Boolean }) isOpen: boolean;

  setPreview(regionIndex: number, imgData: ImageData) {
    const previewCanvas = this.$refs[`scannerPreview${regionIndex + 1}`] as HTMLCanvasElement;
    const previewCanvasCtx = previewCanvas.getContext('2d');
    if (previewCanvasCtx) {
      previewCanvas.width = imgData.width;
      previewCanvas.height = imgData.height;
      previewCanvasCtx.putImageData(imgData, 0, 0);
    }
  }
}
